import { INTEGRATION_MAPPER } from "utils/IntegrationMapper";

export const IntegrationsSection = ({ integrations }) => {
  return (
    <section className="rounded-2xl border bg-card p-6 shadow-sm">
      <h2 className="mb-4 text-xl font-semibold">Integrations</h2>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {integrations.map((item, i) => (
          <div
            key={i}
            className="flex items-center justify-between rounded-lg border p-4 bg-muted/30"
          >
            <span className="font-medium">
              {INTEGRATION_MAPPER.find((m) => m?.key === item)?.value ??
                "Unknown"}
            </span>
            <span
              className={`text-sm font-semibold ${
                "Connected" === "Connected" ? "text-green-600" : "text-red-500"
              }`}
            >
              {item.status || "Connected"}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};
